export function filtro(cadastros, microarea, exibirVermelhos, exibirVerdes) {
  let cadastros_filtrados = cadastros

  if (microarea !== null) {
    cadastros_filtrados = cadastros_filtrados.filter(
      (item) => item.micro_area == microarea.micro_area
    )
  }

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.vacinas_pendentes !== null) {
        let vacinas = JSON.parse(item.vacinas_pendentes)
        let vacina = vacinas.find((el) => {
          return el.id_im == 102 || el.id_im == 86
        })
        if (vacina != undefined) {
          return true
        }
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.vacinas_aplicadas !== null) {
        let vacinas = JSON.parse(item.vacinas_aplicadas)
        let vacina = vacinas.find((el) => {
          return el.id_imuno == 102 || el.id_imuno == 86
        })
        if (vacina != undefined) {
          return true
        }
      }
    })
  }

  return cadastros_filtrados
}
